<template>
  <div v-cloak>
    <div style="padding-left: 30px; padding-right: 30px;">
      <div class="col-lg-12 col-xl-8 grid-filter">
        <filter-options v-bind:pageTitle="pageTitle" v-bind:filterItems="filterItems"
          v-on:filter-updated="filterContract" />
      </div>

      <div style="margin-top: 8px;">
        <b-table responsive show-empty :empty-text="$t('no_service_calls_were_found')" ref="table" :busy.sync="isBusy"
          :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :current-page="currentPage" :per-page="perPage"
          :items="serviceContractsProvider" :fields="fields" @sort-changed="sortingChanged">
          <template v-slot:table-busy>
            <div style="height: 32px;">
              <div class="mb-3" style="color: #18385f; position: absolute; left: 50%;">
                <b-spinner></b-spinner>
              </div>
            </div>
          </template>

          <template v-slot:cell(serviceCallId)="data">
            <a v-on:click="callClick(data.item.serviceCallId)" class="row-link">{{ data.item.serviceCallId }}</a>
          </template>

          <template v-slot:cell(serviceObjectId)="data">
            <a v-on:click="objectClick(data.item.serviceObjectId)" class="row-link">{{ data.item.serviceObjectId }}</a>
          </template>

          <template v-slot:cell(openDate)="data">{{ getDateFormatted(data.item.openDate) }}</template>

          <template v-slot:cell(closeDate)="data">{{ getDateFormatted(data.item.closeDate) }}</template>
        </b-table>

        <div class="row" style="text-align: left;">
          <div class="col-sm-6 offset-sm-3">
            <b-pagination v-if="totalRows > 0" align="center" ref="bottomPagination" label-prev-page="first"
              :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0"
              style="margin-top: 10px !important" />
          </div>
          <div class="col-sm-3">
            <div class="form-group row" style="margin-top: 10px;">
              <label for="inputPassword" class="col-sm-7 col-form-label text-right">{{ $t('lines_per_page') }}</label>
              <div class="col-sm-5">
                <b-form-select :options="pageOptions" v-model="perPage" :change="rowsPerPageChange()" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { odata } from './../../mixins/odata.js';
import { grid } from './../../mixins/grid.js';
import FilterOptions from '@/components/filter/FilterOptions.vue';
import { bus } from './../../main.js';

export default {
  name: 'ServiceCalls',
  mixins: [odata, grid],
  components: {
    filterOptions: FilterOptions
  },
  data: function () {
    return {
      filterItems: getFilterDefinition(this),
      pageTitle: 'service_calls_general',
      filter: this.getFilter(this, 'ca-filter').filterString,
      isBusy: false,
      sortBy: this.getSortBy(this, 'ca-sortBy', 'openDate'),
      sortDesc: this.getSortDesc(this, 'ca-sortDesc', true),
      fields: getTableFields(this),
      totalRows: 0,
      currentPage: this.getCurrentPage(this, 'ca-currentPage', 1),
      perPage: this.getPerPage(this, 'ca-perPage', calculateRowsOnScreen()),
      pageOptions: this.getRowsPerPageOptions(calculateRowsOnScreen())
    };
  },
  methods: {
    filterContract(filters) {
      var filterObject = {
        filterString: '',
        items: []
      };

      this.currentPage = 1;
      this.setCurrentPage(this, 'ca-currentPage', 1);

      for (let i = 0; i < filters.length; ++i) {
        let filter = filters[i];
        if (filter.value) {
          var item = {
            id: filter.id,
            value: filter.value
          };

          filterObject.items.push(item);
        }
      }

      this.filter = this.getFilterString(filters, 'serviceCalls');

      filterObject.filterString = this.filter;

      var jsonItems = JSON.stringify(filterObject);

      this.setFilter(this, 'ca-filter', jsonItems);

      var self = this;

      setTimeout(function () {
        self.$refs.table.refresh();
      }, 500);
    },
    sortingChanged(ctx) {
      ctx.currentPage = 1;
      this.setCurrentPage(this, 'ca-currentPage', 1);
    },
    serviceContractsProvider(ctx) {
      var url = this.getServiceUr(
        'servicecalls',
        ctx,
        this.filter,
        this.generateOdataOrderByConditionString(ctx.sortBy, ctx.sortDesc, 'serviceCalls')
      );

      this.setSortBy(this, 'ca-sortBy', ctx.sortBy);
      this.setSortDesc(this, 'ca-sortDesc', ctx.sortDesc);
      this.setCurrentPage(this, 'ca-currentPage', ctx.currentPage);

      let promise = this.$axios.get(url);

      return promise
        .then(data => {
          const items = data.data.value;

          this.totalRows = data.data.count;

          this.currentPage = this.getCurrentPage(this, 'ca-currentPage', 1);

          // items[2]._rowVariant = 'danger';

          return items;
        })
        .catch(error => {
          console.log(error);

          return [];
        });
    },
    callClick: function (callNumber) {
      this.$router.push({
        name: 'service-call',
        params: {
          id: callNumber
        }
      });
    },
    objectClick: function (objectNr) {
      this.$router.push({
        name: 'service-object',
        params: {
          id: objectNr
        }
      });
    },
    changeLanguageHandler() {
      this.fields = getTableFields(this);
      this.$refs.table.refresh();
    },
    rowsPerPageChange: function () {
      this.setPerPage(this, 'ca-perPage', this.perPage);
    },
    getDateFormatted: function (date) {
      return (date === null || date === '') ? '' : this.$moment(date).format('DD/MM/YYYY');
    }
  },
  created() {
    bus.$on('languageChanged', this.changeLanguageHandler);
  },
  beforeDestroy() {
    bus.$off('languageChanged', this.changeLanguageHandler);
  }
};

function calculateRowsOnScreen() {
  var tableHeight = window.innerHeight - 440;

  var maxRows = tableHeight / 40;

  if (maxRows < 3) {
    return 5;
  }

  return Math.floor(maxRows);
}

function getFilterDefinition(context) {
  var filter = context.getFilter(context, 'ca-filter');

  const filterDefinition = [
    { id: 'serviceCallId', value: '', type: 'input' },
    { id: 'closeDate', value: '', type: 'dateRange' },
    { id: 'callType', value: '', type: 'dropdown', page: 'serviceCalls' },
    { id: 'callStatus', value: '', type: 'dropdown', page: 'serviceCalls' },
    { id: 'serviceObjectId', value: '', type: 'input' },
    { id: 'openDate', value: '', type: 'dateRange' },
    { id: 'openServiceCall', value: '', type: 'checkBox' },
    { id: 'serialNo', value: '', type: 'input' },
    { id: 'itemId', value: '', type: 'input' },
    { id: 'receivedBy', value: '', type: 'dropdown', page: 'serviceCalls' },
    { id: 'objectType', value: '', type: 'dropdown', page: 'serviceCalls' }
  ];

  filter.items.forEach(item => {
    filterDefinition.forEach(filter => {
      if (item.id === filter.id) {
        filter.value = item.value;
      }
    });
  });

  return filterDefinition;
}

function getTableFields(context) {
  return [
    {
      key: 'serviceCallId',
      label: context.$t('call'),
      sortable: true,
      thClass: 'th-200 tr-left custom-th',
      tdClass: 'tr-200 tr-left custom-tr'
    },
    {
      key: 'serviceObjectId',
      label: context.$t('object'),
      sortable: true,
      thClass: 'th-200 tr-left custom-th',
      tdClass: 'tr-200 tr-left custom-tr'
    },
    {
      key: 'serialNo',
      label: context.$t('serialNo'),
      sortable: true,
      thClass: 'th-300 tr-left custom-th',
      tdClass: 'tr-300 tr-left custom-tr'
    },
    {
      key: 'objectType',
      label: context.$t('object_description'),
      sortable: true,
      thClass: 'th-300 tr-left custom-th',
      tdClass: 'tr-300 tr-left custom-tr'
    },
    {
      key: 'description',
      label: context.$t('description'),
      sortable: true,
      thClass: 'th-250 tr-left custom-th',
      tdClass: 'tr-250 tr-left custom-tr'
    },
    {
      key: 'callType',
      label: context.$t('contractType'),
      sortable: true,
      thClass: 'th-200 tr-left custom-th',
      tdClass: 'tr-200 tr-left custom-tr'
    },
    {
      key: 'callStatus',
      label: context.$t('status'),
      sortable: true,
      thClass: 'th-200 tr-left custom-th',
      tdClass: 'tr-200 tr-left custom-tr'
    },
    {
      key: 'openDate',
      label: context.$t('open_date'),
      sortable: true,
      thClass: 'th-200 tr-left custom-th',
      tdClass: 'tr-200 tr-left custom-tr'
    },
    {
      key: 'closeDate',
      label: context.$t('close_date'),
      sortable: true,
      thClass: 'th-200 tr-left custom-th',
      tdClass: 'tr-200 tr-left custom-tr'
    },
    {
      key: 'itemId',
      label: context.$t('itemId'),
      sortable: true,
      thClass: 'th-200 tr-left custom-th',
      tdClass: 'tr-200 tr-left custom-tr'
    },
    {
      key: 'receivedBy',
      label: context.$t('receivedBy'),
      sortable: true,
      thClass: 'th-200 tr-left custom-th',
      tdClass: 'tr-200 tr-left custom-tr'
    }
  ];
}
</script>

<style>
.table-danger th,
.table-danger td,
.table-danger thead th,
.table-danger tbody+tbody {
  background-color: #e9ecef;
  border-color: #e9ecef;
}
</style>
